import { $$ } from "./util.js";

// Clone track content once for a seamless loop.
export function initMarquee() {
  $$(".mq-track").forEach((t) => {
    Array.prototype.slice.call(t.children).forEach((n) => {
      const c = n.cloneNode(true);
      c.setAttribute("aria-hidden", "true");
      t.appendChild(c);
    });
  });
}
